import React, { useEffect, useState } from "react";
import {
  fetchAdminJson,
  fetchAllPages,
  AdminDisclosureCard,
} from "../settingsHelpers";

export function TeamsTab({ onContextChange }) {
  const [teams, setTeams] = useState([]);
  const [form, setForm] = useState({ name: "" });
  const [error, setError] = useState("");
  const [createOpen, setCreateOpen] = useState(false);

  const loadTeams = async () => {
    try {
      const data = await fetchAllPages("/api/accounts/teams/");
      setTeams(data);
    } catch(err) { setError(err.message); }
  };

  useEffect(() => { loadTeams(); }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    try {
      setError("");
      await fetchAdminJson("/api/accounts/teams/", {
        method: "POST",
        body: JSON.stringify(form)
      });
      setForm({ name: "" });
      await loadTeams();
      onContextChange?.();
    } catch(err) { setError(err.message); }
  };

  return (
    <div className="settings-stack">
      {error && <div className="message-banner error">{error}</div>}
      <AdminDisclosureCard
        title="Add Team"
        description="Create a new team before assigning managers and agents."
        actionLabel="Open Form"
        open={createOpen}
        onToggle={() => setCreateOpen((current) => !current)}
      >
        <form className="form-grid settings-form-card-inner" onSubmit={handleCreate}>
          <label className="field-stack">
            <span>Team Name</span>
            <input required value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} />
          </label>
          <div className="settings-form-card-actions full-span">
            <button className="primary-button" type="submit">Create Team</button>
          </div>
        </form>
      </AdminDisclosureCard>

      <div className="settings-card settings-table-card">
        <div className="settings-card-header">
          <div>
            <p className="login-kicker">Teams</p>
            <h3>Available Teams</h3>
          </div>
          <span className="agent-badge mint">{teams.length} total</span>
        </div>
        <ul className="settings-list-grid">
          {teams.map(t => (
            <li key={t.id} className="settings-list-card">
              <strong>{t.name}</strong>
              <span>ID: {t.id}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default TeamsTab;
